import { FieldHookConfig, useField } from 'formik';

import { DatePicker, DatePickerProps } from '../../../components/DatePicker';

interface DatePickerExtraProps {
  name: string; // Use 'name' to align with useField expected field name
}

type FormDatePickerProps = DatePickerProps &
  DatePickerExtraProps &
  FieldHookConfig<Date | null>;

/** @type { React.FC<Props> } */
export const FormDatePicker: React.FC<FormDatePickerProps> = (props) => {
  const [field, meta, helpers] = useField(props);
  const { onChange } = props;

  const { setValue } = helpers;

  return (
    <DatePicker
      slotProps={
        {
          textfield: {
            error: !!(meta.touched && meta.error),
            helpertext: meta.touched && meta.error,
          },
        } as any
      }
      error={!!(meta.touched && meta.error)}
      helperText={meta.touched && meta.error ? meta.error : props.helperText}
      {...field}
      {...props}
      onChange={(value, context) => {
        setValue(value);
        if (onChange) onChange(value, context);
      }}
    />
  );
};
